export default {
    manage_createEditLocation_EditTitle: "Edit Location",
    manage_createEditLocation_CreateTitle: "Create Location",
    manage_createEditLocation_success: "The Location was created successfully",
    manage_createEditLocation_success_edit: "The Location was updated successfully",
    manage_createEditLocation_duplicatedLocationErrorMessage: "This Location already exists",
    manage_createEditLocation_TitleInputLabel: "Location Name",
    manage_createEditLocation_AddressInputLabel: "Address",
    manage_createEditLocation_EnabledELDRuleLabel: "Enable ELD 150 miles Rule",
}